const orderBy = require('lodash/orderBy');
const unionBy = require('lodash/unionBy');
const filter = require('lodash/filter');

const inject = ['productsService', '$scope', '$q', 'toastService', 'ogsdk.productService', '$filter'];

function SkuSwapControllerFactory(productsService, $scope, $q, toastService, productService, $filter) {
  class SkuSwapController {
    constructor() {
      this.loading = true;
      this.groupType = 'sku_swap';
      this.currencySymbol = $filter('translate')('CURRENCY_SYMBOL');
    }

    $onInit() {
      const groups = filter(this.subscription.product.groups, { groupType: this.groupType });
      const promises = [];

      this.selectedProductId = this.subscription.product.externalProductId;

      groups.forEach((group) => {
        promises.push(
          productService.getAll({ groupType: this.groupType, groupName: group.name, pageSize: 100 }, { cache: true })
        );
      });

      return $q.all(promises).then((response) => {
        let productsArray = [];
        response.forEach((responseProducts) => {
          productsArray = unionBy(productsArray, responseProducts, 'externalProductId');
        });
        return productsArray;
      }).then((variants) => {
        this.variantProducts = orderBy(variants, { externalProductId: this.selectedProductId }, 'desc');
      }).finally(() => {
        this.loading = false;
      });
    }

    changeProduct(variant) {
      this.loading = true;

      return productsService.changeProduct(this.subscription.publicId, variant)
        .then(() => toastService.translate.success('TOAST_SKU_SWAP_SUCCESS'))
        .then(() => $scope.$emit('ogOnChangeProduct'))
        .catch(() => toastService.translate.danger('TOAST_SKU_SWAP_DANGER'))
        .finally(() => {
          this.loading = false;
        });
    }
  }

  return new SkuSwapController();
}

SkuSwapControllerFactory.$inject = inject;

angular.module('msi.products')
  .controller('SkuSwapController', SkuSwapControllerFactory);

module.exports = SkuSwapControllerFactory;
